/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddProjectToWorkspaceBody { 
    /**
     * The environment of the project in the workspace. Can be one of \"prod\" or \"dev\". Note that the number of projects in the \"prod\" environment is limited depending on the subscription. prod Production stage Staging dev Development
     */
    environment: AddProjectToWorkspaceBody.EnvironmentEnum;
    /**
     * The action to take with the project subscription. Can be one of \"migrate\", and \"ignore\". \"migrate\" will migrate the project subscription to the workspace. \"ignore\" will ignore the project subscription. migrate ProjectSubscriptionActionMigrate  ProjectSubscriptionActionMigrate will migrate the project subscription to the  workspace. ignore ProjectSubscriptionActionIgnore  ProjectSubscriptionActionIgnore will ignore the project subscription.
     */
    project_subscription: AddProjectToWorkspaceBody.ProjectSubscriptionEnum;
}
export namespace AddProjectToWorkspaceBody {
    export type EnvironmentEnum = 'prod' | 'stage' | 'dev';
    export const EnvironmentEnum = {
        Prod: 'prod' as EnvironmentEnum,
        Stage: 'stage' as EnvironmentEnum,
        Dev: 'dev' as EnvironmentEnum
    };
    export type ProjectSubscriptionEnum = 'migrate' | 'ignore';
    export const ProjectSubscriptionEnum = {
        Migrate: 'migrate' as ProjectSubscriptionEnum,
        Ignore: 'ignore' as ProjectSubscriptionEnum
    };
}


